export default __webpack_public_path__ + "static/media/Renu Malhotra.f3a0f6db.jpg";